import React, { FormEvent, FormEventHandler, forwardRef, ReactNode, Ref } from 'react';

interface IProps {
  children?: ReactNode;
  noPreventDefault?: boolean;
  disabled?: boolean;
  onSubmit?: FormEventHandler<HTMLFormElement>;
}

const Form = forwardRef(({ disabled, noPreventDefault, onSubmit, ...props }: IProps, ref: Ref<HTMLFormElement>) => {
  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    if (!noPreventDefault) {
      event.preventDefault();
    }
    if (!disabled && onSubmit) {
      onSubmit(event);
    }
  };
  return <form data-testid="form" onSubmit={handleSubmit} ref={ref} {...props} />;
},
);

export default Form;
